import { WorkflowPreset } from '../types';

export const reviewPreset: WorkflowPreset = {
  id: 'review',
  label: 'Study Review',
  toolbar: {
    hiddenButtonIds: [
      'MeasurementTools',
      'Probe',
      'Angle',
      'CobbAngle',
      'CalibrationLine',
      'AdvancedMagnify',
    ],
  },
  panels: {
    right: ['@curvebeamai/ohif-extension.panelModule.segmentationReview'],
    rightPanelClosed: false,
  },
  header: {
    showPatientInfo: true,
    showReturnButton: false,
  },
  customizations: {
    'studyBrowser.hideFilterBar': false,
    'header.hideUndoRedo': true,
  },
  dataFilters: {
    skipSeriesFilter: true,
    skipImageSetFilter: true,
    scopeToUrlSeriesAndRelated: {
      sopClassUIDs: ['1.2.840.10008.5.1.4.1.1.66.4', '1.2.840.10008.5.1.4.1.1.66.7'],
      modalities: ['SEG'],
    },
  },
  imageInterpolation: 'NEAREST',
  defaultVoi: { windowWidth: 2500, windowCenter: 480 },
};
